var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.3906V15.3906H20V13.3906H4ZM4 2.39062H20C20.55 2.39062 21.0208 2.58646 21.4125 2.97813C21.8042 3.36979 22 3.84063 22 4.39063V15.3906C22 15.9406 21.8042 16.4115 21.4125 16.8031C21.0208 17.1948 20.55 17.3906 20 17.3906H16V22.3906L12 20.3906L8 22.3906V17.3906H4C3.45 17.3906 2.97917 17.1948 2.5875 16.8031C2.19583 16.4115 2 15.9406 2 15.3906V4.39063C2 3.84063 2.19583 3.36979 2.5875 2.97813C2.97917 2.58646 3.45 2.39062 4 2.39062ZM4 10.3906H20V4.39063H4V10.3906Z",
    fill: "#397431"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeLicense);
export default __webpack_public_path__ + "static/media/trade-license.da1cf2f3a92e1ce7ac752c36465eb9a6.svg";
export { ForwardRef as ReactComponent };